import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PROJECT} from '../../constants';

export default {
  id: 'QUITUS_OPER',
  title: 'Qu’est-ce que le Quitus opération ?',
  description: '',
  categories: [CONTENT_CATEGORY_PROJECT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Le Quitus Opération est la synthèse de votre dossier pour une opération donnée. Il indique l’état des documents requis pour cette opération. Il remplace les nombreux documents obligatoires à fournir lors d’une signature et simplifie alors vos échanges avec vos partenaires. Vous pouvez consulter les documents nécessaires pour une opération. Pour cela : '
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Depuis l’onglet Opérations, en cliquant sur l’opération'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_QUITUS_OPER/FR_QUITUS_OPER_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Cliquez sur les 3 points en haut à droite'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_QUITUS_OPER/FR_QUITUS_OPER_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Puis sur « Voir les documents requis »'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}fr/FR_QUITUS_OPER/FR_QUITUS_OPER_3.png`
  }]
};
